import { render, staticRenderFns } from "./DialogGuaranteeReduceIncome.vue?vue&type=template&id=2bc8a754&"
import script from "./DialogGuaranteeReduceIncome.vue?vue&type=script&lang=js&"
export * from "./DialogGuaranteeReduceIncome.vue?vue&type=script&lang=js&"
import style0 from "./DialogGuaranteeReduceIncome.vue?vue&type=style&index=0&id=2bc8a754&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports